import React from 'react';
import PropTypes from 'prop-types';
import { If } from 'components/if-statement';
import { withOptionGroup } from './logic';
import Option from 'components/option';
import { Label, GroupLayout, OptionsLayout, ErrorMessage } from './style';

function OptionGroup(props) {
  const {
    display,
    errorMessage,
    label,
    invalid,
    renderOptions,
    className,
  } = props;
  return (
    <GroupLayout className={className}>
      <If condition={label}>
        <Label $invalid={invalid}>{label}</Label>
      </If>
      <OptionsLayout display={display}>{renderOptions()}</OptionsLayout>
      <If condition={errorMessage}>
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </If>
    </GroupLayout>
  );
}

OptionGroup.propTypes = {
  display: PropTypes.oneOf(['column', 'row']),
  errorMessage: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  invalid: PropTypes.bool.isRequired,
  renderOptions: PropTypes.func.isRequired,
};

OptionGroup.defaultProps = {
  display: 'row',
  errorMessage: '',
  label: '',
};

export default withOptionGroup(OptionGroup, Option);
